import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BookOfShadowsGameConfig} from "../../BookOfShadowsGameConfig";
import {SoundManager} from "../../sound/SoundManager";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";

export class BookOfShadowsScatterWinView extends BaseView {
    private _transformAnimations: TimelineSprite[][] = [];
    private _layer: ScalableLayer;

    /**
     * @description To play the transform animation and then replace the symbol.
     * @param reelId
     * @param symId
     * @param sym
     * @param name
     */
    public playAnim(reelId: number, symId: number, name: string): void {
        const sym = Reels.getSymbol(reelId, symId);
        if (sym) {
            this._transformAnimations[reelId][symId].getAnimationAutoShowHide(true, true);
            sym.replaceWith(name, reelId, BookOfShadowsGameConfig.instance.SYMBOL_STATES.goldNormal);
            SoundManager.playFSNewSymbols();
        }
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();
        const len: number = 5;

        this._layer = StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.SYMBOLS_TRANSFORM.name);
        this._layer.addChild(this);

        for (let i = 0; i < len; i++) {
            this._transformAnimations.push([]);

            for (let j = 0; j < len; j++) {
                const pos: number[] = Helper.getSymbolPositions(i, j);
                let item: TimelineSprite = new TimelineSprite(GameResources.getTextures("symbolsTransform"));
                item.visible = false;
                item.anchor.set(0.5);
                item.blendMode = PIXI.BLEND_MODES.ADD;
                item.position.set(pos[0], pos[1]);
                this.addChild(item);
                this._transformAnimations[i].push(item);
            }
        }
    }
}